export const inventoryReconciliationTabsData = [
    { label: 'For Review', value: 'for-review' },
    { label: 'Matched', value: 'matched' },
    { label: 'Excluded', value: 'excluded' },
    { label: 'AI Matching', value: 'ai-matching', isBeta: true },
    { label: 'File Upload', value: 'file-upload' },
    { label: 'Purchases', value: 'purchase-activity' },
    { label: 'Exclusion Rules', value: 'exclusion-rules' },
    { label: 'Payment Plan', value: 'payment-plan' },
];
